"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _uuid = require("../../utils/uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ErrorMessagesList = _ref => {
  let {
    errorMessages = [],
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, null, errorMessages.map(errorText => /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    key: (0, _uuid.getUid)()
  }, errorText)), children));
};
var _default = exports.default = ErrorMessagesList;